<template>
  <div>
    <el-upload class="avatar-uploader"
               :disabled="disabled"
               :action="action"
               :show-file-list="false"
               :auto-upload="true"
               :on-success="handleAvatarSuccess"
               :http-request="myUpload"
               :before-upload="beforeAvatarUpload">
      <img v-if="src"
           :src="src"
           class="avatar">
      <i v-else
         class="el-icon-plus avatar-uploader-icon"></i>
    </el-upload>
  </div>
</template>

<script>
import axios from 'axios'
import * as imageConversion from 'image-conversion'
export default {
  name: 'BoyoUpload',
  props: {
    action: String,
    src: String,
    value: String,
    disabled: Boolean
  },
  data () {
    return {
    }
  },
  mounted () {

  },
  methods: {
    handleRemove (file) {
      console.log(file);
    },
    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleDownload (file) {
      console.log(file);
    },
    myUpload (content) {
      axios({
        method: 'post',
        url: content.action,
        data: content.file,
        headers: {
          'Content-Type': 'image/jpeg'
        }
      }).then(res => {
        content.onSuccess(res.data)
      })
    },
    beforeAvatarUpload (file) {
      const isLt2M = file.size / 1024 / 1024 < 10
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 10MB!')
      }
      // const isLt2 = file
      return isLt2M
      // return new Promise((resolve, reject) => {
      //   const isLt2M = file.size / 1024 / 1024 < 5;
      //   // console.log(isLt2M, 22)


      //   if (!isLt2M) {
      //     // this.$message.error('上传图片大小不能超过 5MB!');
      //     imageConversion.compressAccurately(file, 500).then(res => {
      //       resolve(res)
      //     })
      //   }
      //   // return isLt2M
      // })
      return new Promise((resolve, reject) => {
        // const isLt2M = file.size / 1024 / 1024 < 5;
        imageConversion.compressAccurately(file, 500).then(res => {
          resolve(res)
        })
        return isLt2M
      })

    },
    handleAvatarSuccess (res, file, fileList) {
      this.$emit('on-success', res, file, fileList, this.value)
    }
  }
}
</script>
<style lang="stylus" scoped>
.avatar-uploader>>> .el-upload
  border 1px dashed #d9d9d9
  border-radius 6px
  cursor pointer
  position relative
  overflow hidden
.avatar-uploader>>> .el-upload:hover
  border-color #409EFF
.avatar-uploader-icon
  font-size 28px
  color #8c939d
  width 200px
  height 200px
  line-height 200px
  text-align center
.avatar
  width 200px
  height 200px
  display block
</style>



// WEBPACK FOOTER //
// src/components/BoyoUploadtwo/index.vue